/**
 * Sahne mutasyon sistemi (sync faz).
 *
 * SceneMutationObserver dirty bayragini tuketince: aktif sahnedeki asset'leri
 * AssetRegistry'ye track eder (kim eklerse eklesin otomatik yakalanir) ve
 * "scene-mutated" event'ini yayar. Karenin en basinda calisir.
 */
import { AssetRegistry } from "../../loader/AssetRegistry";
import { SceneMutationObserver } from "../SceneMutationObserver";
import type { EngineSystem, FrameContext } from "../runtime/EngineSystem";

export class SceneMutationSystem implements EngineSystem {
  readonly name = "sceneMutation";

  sync(ctx: FrameContext): void {
    const engine = ctx.engine;
    if (SceneMutationObserver.consumeDirty(engine)) {
      AssetRegistry.track(engine.activeScene);
      engine.dispatchCustomEvent("scene-mutated", {
        detail: engine.activeScene,
      });
    }
  }
}
